<template>
<div class="footer-login-wrapper" :style="backgroundStyles">
  <h2 class="font-black
    pc:text-[40px]
    mobile:text-[22px]">{{$t('footer.title')}}</h2>
  <h3 class="font-normal
    pc:pl-[calc(243px-210px)] pc:text-[24px]
    mobile:text-[18px]">{{$t('footer.sub_title')}}</h3>
  <FooterLoginBtnGroup></FooterLoginBtnGroup>
</div>
</template>
<script setup>
import FooterLoginBtnGroup from '@/components/SearchIndex/FooterLogin/FooterLoginBtnGroup.vue'
const img = useImage();
const backgroundStyles = computed(() => {
  const imgUrl = img('/background/footerLogin.jpg', { sizes: '100vw' ,  loading:"lazy",  format: 'webp', quality: 80 })
  return { backgroundImage: `url('${imgUrl}')` }
})
</script>
<style scoped
       lang="scss">
.footer-login-wrapper{
  @apply
  pc:pt-[72px] pc:pl-[210px] pc:h-[300px] pc:bg-cover pc:bg-[center_56%]
  mobile:py-[27px] mobile:pl-[30px] mobile:bg-[length:115%] mobile:bg-[left_75%] mobile:bg-no-repeat;
 /* background-image: url("@/assets/image/background/footerLogin.jpg");*/
}

</style>
